__turbopack_context__.v({
  "blok-big-title": "QuantityCounter-module__7dd0ra__blok-big-title",
  "blok-subtitle": "QuantityCounter-module__7dd0ra__blok-subtitle",
  "blok-title": "QuantityCounter-module__7dd0ra__blok-title",
  "quantity-button": "QuantityCounter-module__7dd0ra__quantity-button",
  "quantity-input": "QuantityCounter-module__7dd0ra__quantity-input",
  "yarn-quantity-disabled": "QuantityCounter-module__7dd0ra__yarn-quantity-disabled",
  "yarn-quantity-large": "QuantityCounter-module__7dd0ra__yarn-quantity-large",
});
